import React from 'react';
import Icon from 'src/react/components/icon/Icon';

const EmptyIdeaList = () => (
  <>
    <div className="items-start justify-center mb-12" data-testid="empty-list">
      <Icon name="flame" className="mb-2" />
      <h1 className="font-normal text-gray-60 text-6">
        Check back soon for <br />
        more recommendations.
      </h1>
    </div>
  </>
);
EmptyIdeaList.propTypes = {};

export default EmptyIdeaList;
